// removed by extract-text-webpack-plugin
module.exports = {"button":"LinkButton_button_2TltA"};